module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr-ca":{"MAPS":"CARTES","TRAILS":"PISTES","LIFTS":"REMONTÉES","UPHILL":"ASCENSION","maps":"CARTES","trails":"PISTES","lifts":"REMONTÉES","uphill":"ASCENSION"}}')
  delete Component.options._Ctor
}
